import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import fetcher from "@/common/axiosInstance";

// Types for the actual API response

// Enhanced type with calculated fields and car data
var PersonalizedPromoCodeApi = /*#__PURE__*/function () {
  function PersonalizedPromoCodeApi() {
    _classCallCheck(this, PersonalizedPromoCodeApi);
  }
  return _createClass(PersonalizedPromoCodeApi, [{
    key: "transformApiResponse",
    value:
    /**
     * Transform API response to our format
     */
    function transformApiResponse(apiData) {
      if (!apiData) {
        return null;
      }
      var carDetails = apiData.car_details;
      var g4Data = carDetails.g4_data_layer;

      // Transform car details
      var transformedCarDetails = {
        id: carDetails.id,
        title: carDetails.title,
        title_ar: carDetails.title_ar,
        title_en: carDetails.title_en,
        price: g4Data.post_price,
        sellingprice_formatted: carDetails.sellingprice,
        currency: 'SAR',
        image_url: carDetails.image_url,
        images: carDetails.images_urls,
        make: g4Data.post_make,
        model: g4Data.post_model,
        year: carDetails.year,
        ext: g4Data.post_ext,
        location: carDetails.city_name,
        condition: g4Data.post_condition,
        fuel_type: g4Data.post_fuel,
        transmission: g4Data.post_transmission,
        color_variants: carDetails.color_variants,
        tags: carDetails.tags,
        product_url: carDetails.product_url,
        is_booked: carDetails.is_booked
      };
      return {
        code: apiData.code,
        promo_type: apiData.promo_type,
        discount_amount: parseFloat(apiData.discount_amount),
        expiry_time: apiData.expiry_time,
        expires_at: new Date(apiData.expiry_time),
        closed_at: apiData.closed_at,
        // Include closed_at field
        post_id: apiData.post_id.toString(),
        car_details: transformedCarDetails,
        views_count: apiData.views_count || 0 // Optional field for views count
      };
    }

    /**
     * Get personalized promo code for a specific post
     * @param postId - The post ID (optional, will be used if needed)
     * @param uid - The device UID (optional)
     * @param userId - The logged-in user ID (optional, takes priority over uid)
     */
  }, {
    key: "api__getPersonalizedPromoCode",
    value: (function () {
      var _api__getPersonalizedPromoCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(uid, userId) {
        var queryParams, queryString, url, response, promoData, _error$response, _error$response$data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              // Build query parameters
              queryParams = new URLSearchParams(); // Add user_id if provided (logged-in user takes priority)
              if (userId) {
                queryParams.append('user_id', userId);
              }
              if (uid) {
                queryParams.append('device_id', uid);
              }
              queryString = queryParams.toString();
              url = "/personalized-promo-code/get-code".concat(queryString ? "?".concat(queryString) : '');
              _context.n = 1;
              return fetcher().get(url);
            case 1:
              response = _context.v;
              if (!response.data.success) {
                _context.n = 2;
                break;
              }
              promoData = this.transformApiResponse(response.data.data);
              return _context.a(2, {
                success: true,
                data: promoData
              });
            case 2:
              return _context.a(2, {
                success: false,
                error: response.data.error || 'No promo code available'
              });
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              return _context.a(2, {
                success: false,
                error: ((_error$response = _t.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.error) || _t.message || 'Failed to fetch promo code'
              });
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[0, 4]]);
      }));
      function api__getPersonalizedPromoCode(_x, _x2) {
        return _api__getPersonalizedPromoCode.apply(this, arguments);
      }
      return api__getPersonalizedPromoCode;
    }())
  }]);
}();
export var personalizedPromoCodeApi = new PersonalizedPromoCodeApi();